import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import DOMPurify from "dompurify";
import { ActionTextType } from "@vfit/shared/models";
import { purifyTextWithLogo } from "@vfit/shared/data-access";
import { CustomTextContainer } from "./customText.style";
/**
 * component to render custom text. Comply with all html standards.
 * To insert a custom button with a defined action you need to use
 * <button> 5G <span data-action = 'product'> + </span> </button>
 * specifying data-action
 * @param text
 * @param textAlign
 * @param onClickType
 * @param anchorScroll
 * @param sizeMobile
 * @param size
 * @param lineHeight
 * @param lineHeightMobile
 * @param fontFamily
 * @param modal
 * @param disableOrganizeText
 * @constructor
 */ var CustomText = function(param) {
    var text = param.text, textAlign = param.textAlign, onClickType = param.onClickType, anchorScroll = param.anchorScroll, sizeMobile = param.sizeMobile, size = param.size, lineHeight = param.lineHeight, lineHeightMobile = param.lineHeightMobile, fontFamily = param.fontFamily, modal = param.modal, margin = param.margin, disableOrganizeText = param.disableOrganizeText;
    DOMPurify.addHook("afterSanitizeAttributes", function(node) {
        // check for security issue
        // set all elements owning target to rel=noopener
        // https://developer.chrome.com/docs/lighthouse/best-practices/external-anchors-use-rel-noopener/
        if ("target" in node) {
            node.setAttribute("rel", "noopener");
        }
    });
    var sanitizeText = DOMPurify.sanitize(text, {
        ADD_ATTR: [
            "target"
        ]
    });
    var handleClick = useCallback(function(e) {
        var element = e.target;
        var dataAction = element.getAttribute("data-action");
        var dataDescription = element.getAttribute("data-desc");
        var dataTitle = element.getAttribute("data-title");
        if ((dataAction || dataDescription) && onClickType && dataAction in ActionTextType) {
            onClickType(ActionTextType[dataAction], dataDescription, dataTitle);
        }
    }, [
        onClickType
    ]);
    return /*#__PURE__*/ _jsx(CustomTextContainer, {
        textAlign: textAlign || "center",
        dangerouslySetInnerHTML: {
            __html: disableOrganizeText ? sanitizeText : purifyTextWithLogo(sanitizeText)
        },
        onClick: handleClick,
        id: anchorScroll ? "anchorScroll" : "",
        sizeMobile: sizeMobile || size,
        size: size,
        lineHeight: lineHeight,
        lineHeightMobile: lineHeightMobile || lineHeight,
        fontFamily: fontFamily,
        modal: modal,
        margin: margin
    });
};
export default CustomText;
